// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9c46abd076194e554d66","655":"360dfe1d84b8e1198b05"}[chunkId] + ".js";
};